import { Grid } from '@mui/material'
import { Title } from 'components'
import { useLayout } from 'context'
import { getOutboundTripDetail } from 'controllers/outboundTrips/index'
import { OutboundTripDetailDto } from 'dtos/outboundTrips'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ManageVehiclesCard from './ManageVehiclesCard'
import NotesCard from './NotesCard'
import OutboundTripDetailsCard from './OutboundTripDetailCard'
import PhotosCard from './PhotosCard'
import DestinationCard from './DestinationCard'

export default function OutboundTripsDetails() {
  const { outboundTripGuid } = useParams()
  const { setIsLayoutLoading } = useLayout()

  const [state, _setState] = useState<OutboundTripDetailDto>()

  useEffect(() => {
    if (!outboundTripGuid) return

    setIsLayoutLoading(true)
    getOutboundTripDetail(outboundTripGuid)
      .then(res => _setState(res.value))
      .finally(() => setIsLayoutLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outboundTripGuid])

  const setState = ({ outboundTrip, vehicles, destination, notes, photos }: OutboundTripDetailDto) => {
    if (!state) return

    let newState = state

    if (outboundTrip) newState = { ...newState, outboundTrip }
    if (vehicles) newState = { ...newState, vehicles }
    if (destination) newState = { ...newState, destination }
    if (notes) newState = { ...newState, notes }
    if (photos) newState = { ...newState, photos }

    _setState(newState)
  }

  return (
    <>
      <Title>Outbound Trip Details</Title>

      <Grid container spacing={1} alignItems='flex-start'>
        <Grid item xs={12}>
          <OutboundTripDetailsCard outboundTrip={state?.outboundTrip} outboundTripGuid={outboundTripGuid} setState={setState} />
        </Grid>

        <Grid item xs={12}>
          <ManageVehiclesCard outboundTripGuid={outboundTripGuid} setState={setState} vehicles={state?.vehicles} />
        </Grid>

        <Grid item xs={12} sm={4}>
          <DestinationCard destination={state?.destination} outboundTripGuid={outboundTripGuid} setState={setState} />
        </Grid>

        <Grid item xs={12} sm={4}>
          <NotesCard notes={state?.notes} outboundTripGuid={outboundTripGuid} setState={setState} />
        </Grid>

        <Grid item xs={12} sm={4}>
          <PhotosCard outboundTripGuid={outboundTripGuid} photos={state?.photos} setState={setState} />
        </Grid>
      </Grid>
    </>
  )
}
